module.exports = __webpack_public_path__ + "static/media/Move.c2869bc8.svg";